module.exports = __webpack_public_path__ + "media/images/bubble-img-service-intro-answer-top-9472f5d4f77c055f8f443ba291e981f3.png";